import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BlogData, BlogdetailsData, Bloginsert, contactUs } from '../const';
import { Subject } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class CommonServiceService {
  private challangeRequest = new Subject<any>();
  challangeRequest$ = this.challangeRequest.asObservable();
  constructor(private http: HttpClient) {}

  contactData(data: any) {
    return this.http.post<any>(`${contactUs}`, data);
  }

  deciderequest(isDataAvailable: any) {
    this.challangeRequest.next(isDataAvailable);
  }

  getBlogs(page: number) {
    return this.http.get<any>(`${BlogData}?page=${page}`);
  }

  insertNews(data:any) {
    return this.http.post<any>(`${Bloginsert}?`,data)
  }

  newsIdData(id:any){
    return this.http.get<any>(`${BlogdetailsData}?id=${id}`)
    
  }
}
